import { TextField } from "@mui/material";
import styled from "@emotion/styled";
import myThemes from "../../themes/Themes";
export const StyledTextField = styled(TextField)(() => ({
  "& .MuiFilledInput-root": {
    fontFamily: "Inter",
    background: "#666666 !important",
    color: "white",
  },

  "& .MuiOutlinedInput-root": {
    fontFamily: "Inter",
    color: myThemes["purple"].palette.primary,
  },
  marginBottom: "20px",
}));
